export default "__VITE_ASSET__CYsHN3XO__"